import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { useCanModifyRegionSettings } from "store/selectors/settings";
import { RegionSettingsCommunities } from "./region-settings-communities";
import { RegionSettingsGeneral } from "./region-settings-general";
import { RegionSettingsInvoices } from "./region-settings-invoices";
import { RegionSettingsNav } from "./region-settings-nav";

export const RegionSettings: React.FC<unknown> = () => {
    const showRegionSettings = useCanModifyRegionSettings();

    if (!showRegionSettings) {
        return null;
    }

    return (
        <div className="lg:flex lg:gap-x-5">
            <div className="lg:w-56 lg:shrink-0">
                <RegionSettingsNav />
            </div>
            <div className="lg:flex-1 lg:min-w-0 pb-4">
                <Switch>
                    <Route
                        path="/settings/region/invoices"
                        component={RegionSettingsInvoices}
                    />
                    <Route
                        path="/settings/region/communities"
                        component={RegionSettingsCommunities}
                    />
                    <Route
                        path="/settings/region/general"
                        component={RegionSettingsGeneral}
                    />
                    <Route
                        path="/settings/region"
                        render={() => <Redirect to="/settings/region/invoices" />}
                    />
                </Switch>
            </div>
        </div>
    );
};
